<template>
<g class="fill-none" :style="[strokeStyle]" stroke-linecap="round" stroke-linejoin="round"><path d="M12 18.75a.375.375 0 100 .75.375.375 0 000-.75h0M12 15.75v-7.5"/><path d="M13.621 1.76a1.806 1.806 0 00-3.242 0L.906 21.058a1.52 1.52 0 001.366 2.192h19.456a1.521 1.521 0 001.366-2.192L13.621 1.76z"/></g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
export default {
  name: "IconAlert",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {
  },
  computed: {
  }
};
</script>